module.exports = __webpack_public_path__ + "img/bank_icon8.56bd0fdf.png";